export default __webpack_public_path__ + "static/media/calendar2.349ab79f.svg";